import React, { ReactNode } from 'react';
import { clsx } from 'clsx';

import styles from './Button.module.scss';

export const buttonVariants = [
  'default',
  'text',
  'icon',
  'primaryOutline',
  'primary',
  'secondary',
  'info',
  'danger',
  'link'
] as const;
export type ButtonVariant = (typeof buttonVariants)[number];

export interface ButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  children: ReactNode;
  variant?: ButtonVariant;
  className?: string;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, variant = 'default', ...props }, ref) => (
    <button
      className={clsx(styles.btn, styles[variant], className)}
      ref={ref}
      {...props}
    >
      {children}
    </button>
  )
);

export namespace Button {
  export type Props = ButtonProps;
}
